import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Grid,
  Paper,
  CircularProgress,
  Dialog,
  IconButton,
  Chip,
  Stack,
  CardActions,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert
} from "@mui/material";
import { FiEdit, FiFileText, FiDollarSign, FiImage } from "react-icons/fi";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { vendorApi } from "../../api/api";
import PropertyGallery from "../../Pages/Propertys/propertygallery";
import { useSelector } from "react-redux";
import PlotsList from "../projects/PlotsList";
import ProjectDocuments from "../../Pages/Project/projectdocuments";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";


const parseDescription = (desc) => {
  if (!desc) return [];

  try {
    const parsed = JSON.parse(desc);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

const cleanDescription = (arr) => {
  return [...new Set(arr.map(item => item.trim()))];
};

const getYoutubeEmbedUrl = (url) => {
  if (!url) return null;

  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
  );

  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};


const ViewProject = () => {
  const role = useSelector((state) => state.user.role);
  const location = useLocation();
  const navigate = useNavigate();
  const { ProjectId, ProjectName, City, Address, NoOfPlots, layout_url } = location.state || {};

  const [plotDetails, setPlotDetails] = useState([]);
  const [projectImages, setProjectImages] = useState([]);
  const [projectDocuments, setProjectDocuments] = useState([]);
  const [projectDetails, setProjectDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [layoutDialogOpen, setLayoutDialogOpen] = useState(false);
  const [editLayoutDialogOpen, setEditLayoutDialogOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const [propertVideo, setpropertVideo] = useState([]);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [selectedVideos, setSelectedVideos] = useState(null);
  const [propertyData, setPropertyData] = useState([]);
  const [propertContact, setpropertContact] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [openEditContact, setOpenEditContact] = useState(false);
  const [contactForm, setContactForm] = useState({
    owner_name: "",
    owner_mobile: "",
    owner_email: "",
    owner_address: "",
    reference_name: "",
    reference_mobile: "",
  });
  useEffect(() => {

    if (!ProjectId) return;
    const fetchProjectDetails = async () => {
      try {
        const res = await vendorApi.getProjectDetailsById(ProjectId);
        const data = res.data;

        const plots = data.plots?.map((plot) => ({
          plotId: plot.id,
          PlotName: plot.PropertyName,
          Size: plot.SizeInSqFt,
          SqFtPrice: plot.SqFtPrice,
          Status: plot.Status,
          sqftamount: plot.sqftamount,
          percentagevalue: plot.percentagevalue,
          PropertyType: plot.PropertyType,
          Address: plot.Address,
          City: plot.City,
          IconUrl: plot.IconUrl
        })) || [];
        const images = data.images?.map((img) => ({
          id: img.id,
          ImageURL: img.ImageURL,
        })) || [];
        const documents = data.documents?.map((doc) => ({
          id: doc.id,
          documentName: doc.DocumentName,
          documentUrl: doc.DocumentURL,
        })) || [];

        setProjectDetails({
          ...data.projectdetails,
          Description: data.projectdetails?.Description,
        });

        setPlotDetails(plots);
        setProjectImages(images);
        setProjectDocuments(documents);
      } catch (error) {
        console.error("Error fetching project details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjectDetails();
  }, [ProjectId]);

  useEffect(() => {
    const getProperties = async () => {


      const data = {
        type: 1,
        reference_id: projectDetails.id,
      };

      try {

        setLoading(true);

        const [propervideos, propertycontact] =
          await Promise.all([
            vendorApi.getPropertyVideos(data),
            vendorApi.getPropertyContactDetails(data),

          ]);

        setpropertVideo(propervideos.data.data);
        setpropertContact(propertycontact.data.data)
      } catch (error) {
        console.error("Error fetching property videos:", error);
      } finally {
        setLoading(false);
      }
    };
    getProperties();

  }, [projectDetails]);


  const handleClick = () => {

    navigate('/property/AddImages', {
      state: {
        propertyData: projectDetails
      }
    });
  };

  const addDocument = () => {
    navigate("/viewProject/addDocument", {
      state: {
        ProjectId,
        ProjectName,
        City: projectDetails.city,
        Address: projectDetails.address,
      },
    });
  };

  const handleLayoutOpen = () => {
    setLayoutDialogOpen(true);
  };

  const handleLayoutClose = () => {
    setLayoutDialogOpen(false);
  };

  const handleEditLayoutOpen = () => {
    setEditLayoutDialogOpen(true);
    setError("");
    setSelectedFile(null);
    setPreviewUrl("");
  };

  const handleEditLayoutClose = () => {
    setEditLayoutDialogOpen(false)
    setError("");
    setSelectedFile(null);
    setPreviewUrl("");
  };
  const handleAddVideo = () => {
    setOpenVideoModal(true);
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedVideos(file);
    }
  };


  const handleUploadVideos = async () => {
    if (!selectedVideos) return;



    const formData = new FormData();
    formData.append("type", 1);
    formData.append("reference_id", projectDetails.id);
    formData.append("video", selectedVideos); // ✅ IMPORTANT

    // Debug (optional)
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
    debugger
    try {
      await vendorApi.addpropertyvideos(formData);
      setOpenVideoModal(false);
      setSelectedVideos(null);
      alert("Video Save Successfully");
      navigate(-1)
    } catch (error) {
      console.error("Upload failed", error);
    }
  };



  const handleDeleteVideo = async (id) => {


    if (!window.confirm("Are you sure you want to delete this video?")) return;

    try {

      await vendorApi.deletepropertyvideo({
        id: id,
        type: 1,
        reference_id: projectDetails.id
      });

      alert("Video deleted successfully");
      navigate(-1)

    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  const handleDelete = async (data) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this property?"
    );

    if (!confirmDelete) return; // user clicked Cancel

    let propertyType = 1;

    // if (data.PropertyType === "Property") propertyType = 2;
    // else if (data.PropertyType === "Project") propertyType = 1;
    // else if (data.PropertyType === "Apartment") propertyType = 3;
    // else if (data.PropertyType === "Land") propertyType = 4;

    if (!propertyType) {
      console.error("Invalid PropertyType", data.PropertyType);
      return;
    }

    const deleteItem = {
      PropertyId: Number(data.id),
      PropertyType: Number(propertyType),
    };

    try {
      const response = await vendorApi.deteleProperty(deleteItem);
      alert("Property deleted successfully");

      navigate("/viewProject")
      // refresh list
      // fetchProperties();

    } catch (error) {
      alert("Failed to delete property");
      console.error("Delete failed", error);
    }
  };
  const getPropertyTypeNumber = () => {
    switch (propertyData?.propertyData?.PropertyType) {
      case "Property": return 2;
      case "Project": return 1;
      case "Apartment": return 3;
      case "Individual Villa": return 4;
      default: return null;
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        setError("Please select a valid image file (JPEG, PNG, GIF, WebP)");
        return;
      }

      // Validate file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        setError("File size should be less than 5MB");
        return;
      }

      setSelectedFile(file);
      setError("");

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleSaveLayout = async () => {
    if (!selectedFile) {
      setError("Please select an image file");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('layout_image', selectedFile);
      formData.append('project_id', ProjectId);

      // Call API to upload layout
      const response = await vendorApi.uploadProjectLayout(formData);

      // Update local state with new layout URL
      setProjectDetails(prev => ({
        ...prev,
        layout_url: response.data.layout_url
      }));

      // Close dialog and show success message
      handleEditLayoutClose();
      alert("Layout updated successfully!");

    } catch (error) {
      console.error("Error uploading layout:", error);
      setError("Error uploading layout. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleAddContact = async () => {
    const payload = {
      property_id: projectDetails.id,
      type: 1,
      owner_name: contactForm.owner_name,
      owner_mobile: contactForm.owner_mobile,
      owner_email: contactForm.owner_email,
      owner_address: contactForm.owner_address,
      reference_name: contactForm.reference_name,
      reference_mobile: contactForm.reference_mobile,
    };

    try {
      const response = await vendorApi.addPropertyContactDetails(payload);

      alert("Contact added successfully");

      // ✅ Update UI with backend response
      setpropertContact(response.data.data);

      setOpenEditContact(false);
      setIsEditMode(false);

    } catch (error) {
      console.error("Add contact failed", error);
      alert("Failed to add contact");
    }
  };


  const handleUpdateContact = async () => {


    const payload = {
      property_id: projectDetails.id, // ✅ REQUIRED
      type: 1,                                 // ✅ REQUIRED

      owner_name: contactForm.owner_name,
      owner_mobile: contactForm.owner_mobile,
      owner_email: contactForm.owner_email,
      owner_address: contactForm.owner_address,

      reference_name: contactForm.reference_name,
      reference_mobile: contactForm.reference_mobile,
    };

    try {


      const response = await vendorApi.editecontactdetails(payload);

      alert("Contact updated successfully");

      // ✅ Always trust backend response
      setpropertContact(response.data.data);

      setOpenEditContact(false);
      setIsEditMode(false);

    } catch (error) {
      console.error("Update failed", error);
      alert("Failed to update contact");
    }
  };

  // const handleDeleteLayout = async () => {
  //   if (window.confirm("Are you sure you want to delete the project layout?")) {
  //     try {
  //       console.log(ProjectId);
  //       await vendorApi.deleteProjectLayout({ project_id: ProjectId });

  //       setProjectDetails(prev => ({ ...prev, layout_url: null }));

  //       alert("Layout deleted successfully");
  //     } catch (error) {
  //       console.error("Error deleting layout:", error);
  //       alert("Error deleting layout");
  //     }
  //   }
  // };

  // Get layout URL from projectDetails or props
  const currentLayoutUrl = layout_url || projectDetails?.layout_url;
  return (
    <Container sx={{ py: 5, maxWidth: "90%" }}>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#F9F9F9',
          }}
        >
          <CircularProgress size={60} thickness={3} sx={{ color: '#1976D2' }} />
        </Box>
      ) : (
        <Box sx={{ borderRadius: 2 }}>
          <Typography variant="h4" sx={{ color: "#13216E", fontWeight: 600, mb: 3 }}>
            View Project
          </Typography>

          {/* Project Header with Layout */}
          <Grid container spacing={3}>
            {/* Project Details - Left Side */}
            <Grid item xs={12} md={6}>
              <Card sx={{ boxShadow: 3, borderRadius: "10px", height: "100%" }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Typography variant="h5" sx={{ color: "#13216E", fontWeight: 600 }}>
                      {ProjectName ? ProjectName : projectDetails.project_name}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Chip
                        label={projectDetails.status || "Active"}
                        color={projectDetails.status === "Completed" ? "success" : "primary"}
                        variant="outlined"
                      />
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        startIcon={<DeleteIcon />}
                        onClick={() => handleDelete(projectDetails)}
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          marginLeft: 1,
                          '&:hover': {
                            backgroundColor: 'error.light',
                            color: 'error.contrastText'
                          }
                        }}
                      >
                        Delete
                      </Button>
                    </Box>
                  </Box>

                  <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }}>
                    <Grid item>
                      <LocationOnIcon sx={{ fontSize: 24, color: "#13216E" }} />
                    </Grid>
                    <Grid item xs>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {Address ? Address : projectDetails.address}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {City ? City : projectDetails.city}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Stack spacing={1} sx={{ mt: 2, maxWidth: "50%" }}>
                    <Box sx={{ display: 'flex' }}>
                      <Typography variant="body2" color="text.secondary">
                        <strong>No. of Plots:</strong>
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500, marginLeft: 1 }}>
                        {NoOfPlots ? NoOfPlots : projectDetails.number_of_plots}
                      </Typography>
                    </Box>
                  </Stack>





                </CardContent>
              </Card>
            </Grid>

            {/* Project Layout - Right Side */}
            <Grid item xs={12} md={6}>
              <Card sx={{ boxShadow: 3, borderRadius: "10px", p: 2, height: "100%" }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ color: "#13216E", fontWeight: 600 }}>
                      Project Layout
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {currentLayoutUrl ? (
                        <>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={handleEditLayoutOpen}
                          >
                            Edit
                          </Button>
                          {/* <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={handleDeleteLayout}
                          >
                            Delete
                          </Button> */}
                        </>
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<AddPhotoAlternateIcon />}
                          onClick={handleEditLayoutOpen}
                        >
                          Add Layout
                        </Button>
                      )}
                    </Box>
                  </Box>

                  {currentLayoutUrl ? (
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover .zoom-overlay': {
                          opacity: 1,
                        }
                      }}
                      onClick={handleLayoutOpen}
                    >
                      <img
                        src={currentLayoutUrl}
                        alt="Project Layout"
                        style={{
                          width: '100%',
                          maxWidth: '500px',
                          height: '250px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }}
                      />
                      <Box
                        className="zoom-overlay"
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0,0,0,0.4)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '8px',
                          opacity: 0,
                          transition: 'opacity 0.3s ease',
                        }}
                      >
                        <ZoomInIcon sx={{ color: 'white', fontSize: 48 }} />
                      </Box>
                      <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary', textAlign: 'center' }}>
                        Click on the image to view in full screen
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        height: '250px',
                        border: '2px dashed #e0e0e0',
                        borderRadius: '8px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#fafafa',
                        color: '#9e9e9e'
                      }}
                    >
                      <AddPhotoAlternateIcon sx={{ fontSize: 48, mb: 1 }} />
                      <Typography variant="body2" sx={{ textAlign: 'center' }}>
                        No layout image available
                      </Typography>
                      <Button
                        variant="text"
                        size="small"
                        onClick={handleEditLayoutOpen}
                        sx={{ mt: 1 }}
                      >
                        Upload Layout
                      </Button>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#13216E", mb: 1 }}>
              Description
            </Typography>



            {projectDetails.Description ? (


              <ReactQuill
                value={projectDetails.Description}
                readOnly
                theme="bubble"
              />


            ) : (
              <Typography color="text.secondary">
                No description available
              </Typography>
            )}
          </Box>


          <Box sx={{ width: "100%" }}>
            {/* Rest of the components */}
            <PlotsList plots={plotDetails} NoOfPlots={projectDetails.number_of_plots} role={role} />
          </Box>

          <Box sx={{ mt: 4 }}>
            {/* Header Row */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: "#13216e" }}
              >
                Contact Details
              </Typography>

              {/* Action Buttons - Show Add if no data, Edit if data exists */}
              <Box sx={{ display: "flex", gap: 1 }}>
                {!propertContact ? (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setIsEditMode(false);
                      setContactForm({
                        owner_name: "",
                        owner_mobile: "",
                        owner_email: "",
                        owner_address: "",
                        reference_name: "",
                        reference_mobile: "",
                      });
                      setOpenEditContact(true);
                    }}
                  >
                    Add Contact
                  </Button>

                ) : (
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<FiEdit />}
                    onClick={() => {
                      setIsEditMode(true);
                      setContactForm(propertContact); // preload data
                      setOpenEditContact(true);
                    }}
                  >
                    Edit Contact
                  </Button>


                )}
              </Box>
            </Box>

            {propertContact ? (
              <Grid container spacing={2}>
                {/* Owner Details */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      p: 2
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                      Owner Information
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Name
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.owner_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Mobile
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.owner_mobile || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Email
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.owner_email || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Address
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.owner_address || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>

                {/* Reference Details */}
                {/* <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      p: 2
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                      Reference Information
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Name
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.reference_name || "N/A"}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          Mobile
                        </Typography>
                        <Typography variant="body1">
                          {propertContact.reference_mobile || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid> */}
              </Grid>
            ) : (
              <Card
                sx={{
                  p: 4,
                  textAlign: 'center',
                  border: '1px dashed #ccc',
                  borderRadius: 1,
                  backgroundColor: '#fafafa'
                }}
              >
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                  No contact details available
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setIsEditMode(false);
                    setContactForm({
                      owner_name: "",
                      owner_mobile: "",
                      owner_email: "",
                      owner_address: "",
                      reference_name: "",
                      reference_mobile: "",
                    });
                    setOpenEditContact(true);
                  }}
                >
                  Add Contact Details
                </Button>
              </Card>
            )}
          </Box>

          <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
            <Button variant="contained" onClick={handleClick}>
              Add Images
            </Button>
          </Box>


          <PropertyGallery imageData={projectImages} ProjectId={ProjectId} type={plotDetails[0]?.PropertyType || 'N/A'} />

          <Box sx={{ mt: 4 }}>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Property Videos
              </Typography>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAddVideo}
              >
                Add Video
              </Button>

            </Box>
            <Dialog open={openVideoModal} onClose={() => setOpenVideoModal(false)} fullWidth maxWidth="sm">
              <DialogTitle>Upload Property Video</DialogTitle>

              <DialogContent>
                <Box mt={2}>
                  <input
                    type="file"
                    accept="video/mp4,video/webm,video/quicktime"
                    onChange={handleVideoChange}
                  />

                  {selectedVideos && (
                    <Box mt={1}>
                      <strong>Selected file:</strong> {selectedVideos.name}
                    </Box>
                  )}
                </Box>
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenVideoModal(false)}>
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  startIcon={<UploadIcon />}
                  onClick={handleUploadVideos}
                  disabled={!selectedVideos}
                >
                  Upload
                </Button>
              </DialogActions>
            </Dialog>

            {/* Video List */}
            {propertVideo.length > 0 ? (
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)",
                  },
                  gap: 3,
                }}
              >
                {propertVideo.map((video) => {
                  const embedUrl = getYoutubeEmbedUrl(video.video_url);
                  if (!embedUrl) return null;

                  return (
                    <Card
                      key={video.id}
                      sx={{
                        borderRadius: 3,
                        boxShadow: 3,
                        overflow: "hidden",
                        transition: "0.3s",
                        "&:hover": {
                          boxShadow: 6,
                          transform: "translateY(-4px)",
                        },
                      }}
                    >
                      {/* YouTube iframe */}
                      <iframe
                        src={embedUrl}
                        width="100%"
                        height="200"
                        style={{ border: "none" }}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={`property-video-${video.id}`}
                      />


                    </Card>
                  );
                })}
              </Box>
            ) : (
              <Typography color="text.secondary">No videos available</Typography>
            )}
          </Box>
          <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
            {role !== 'legalteam' && (
              <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
                <Button variant="contained" onClick={addDocument}>
                  Add Documents
                </Button>
              </Box>
            )}
          </Box>
          <ProjectDocuments documentData={projectDocuments} />



          {/* Full Screen Layout Dialog */}
          <Dialog
            open={layoutDialogOpen}
            onClose={handleLayoutClose}
            maxWidth="lg"
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                backgroundColor: 'rgba(0,0,0,0.9)',
                maxHeight: '90vh'
              }
            }}
          >
            <IconButton
              onClick={handleLayoutClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                zIndex: 1,
                backgroundColor: 'rgba(0,0,0,0.5)',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.7)',
                }
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                p: 2
              }}
            >
              <img
                src={currentLayoutUrl}
                alt="Project Layout Full Screen"
                style={{
                  maxWidth: '100%',
                  maxHeight: '85vh',
                  objectFit: 'contain',
                  borderRadius: '4px'
                }}
              />
            </Box>
          </Dialog>

          {/* Edit/Add Layout Dialog */}
          <Dialog
            open={editLayoutDialogOpen}
            onClose={handleEditLayoutClose}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Typography variant="h6" sx={{ color: "#13216E", fontWeight: 600 }}>
                {currentLayoutUrl ? "Edit Project Layout" : "Add Project Layout"}
              </Typography>
            </DialogTitle>
            <DialogContent>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              <Box sx={{ textAlign: 'center', mb: 3 }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileSelect}
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                />

                {previewUrl ? (
                  <Box sx={{ mb: 2 }}>
                    <img
                      src={previewUrl}
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '300px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                    />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      Preview of selected image
                    </Typography>
                  </Box>
                ) : currentLayoutUrl ? (
                  <Box sx={{ mb: 2 }}>
                    <img
                      src={currentLayoutUrl}
                      alt="Current Layout"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '300px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                    />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      Current layout image
                    </Typography>
                  </Box>
                ) : null}

                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  onClick={handleUploadClick}
                  sx={{ mt: 2 }}
                >
                  {currentLayoutUrl ? "Replace Image" : "Select Image"}
                </Button>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Supported formats: JPEG, PNG, GIF, WebP (Max 5MB)
                </Typography>
              </Box>

              {selectedFile && (
                <Box sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                  <Typography variant="body2">
                    <strong>Selected File:</strong> {selectedFile.name}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Size:</strong> {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                  </Typography>
                  <Typography variant="body2">
                    <strong>Type:</strong> {selectedFile.type}
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button onClick={handleEditLayoutClose} disabled={uploading}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveLayout}
                disabled={!selectedFile || uploading}
                startIcon={uploading ? <CircularProgress size={16} /> : null}
              >
                {uploading ? "Uploading..." : (currentLayoutUrl ? "Update Layout" : "Add Layout")}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}

      <Dialog
        open={openEditContact}
        onClose={() => setOpenEditContact(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {isEditMode ? "Edit Contact Details" : "Add Contact Details"}
        </DialogTitle>


        <DialogContent dividers>
          <Grid container spacing={2} mt={1}>

            <Grid item xs={12}>
              <Typography fontWeight={600}>Owner Information</Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Name"
                fullWidth
                value={contactForm.owner_name || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Mobile"
                fullWidth
                value={contactForm.owner_mobile || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_mobile: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Email"
                fullWidth
                value={contactForm.owner_email || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_email: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Owner Address"
                fullWidth
                multiline
                rows={3}
                value={contactForm.owner_address || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, owner_address: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12} mt={2}>
              <Typography fontWeight={600}>Reference Information</Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Name"
                fullWidth
                value={contactForm.reference_name || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, reference_name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Reference Mobile"
                fullWidth
                value={contactForm.reference_mobile || ""}
                onChange={(e) =>
                  setContactForm({ ...contactForm, reference_mobile: e.target.value })
                }
              />
            </Grid>

          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEditContact(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={isEditMode ? handleUpdateContact : handleAddContact}
          >
            {isEditMode ? "Update" : "Save"}
          </Button>

        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ViewProject;